// Pure routing for the Setup Continue / Save & Exit gates — extracted so the branching is
// unit-testable; Setup.tsx owns the side effects (toasts, popovers, saving).

export type ContinueGateDecision =
  'block-unmatched' | 'block-invalid' | 'confirm-continue' | 'proceed';

export interface ContinueGateInput {
  isPaymentRecovery: boolean;
  hasRequiredUnmatched: boolean;
  formInvalid: boolean;
  hasPartialErrors: boolean;
  continueConfirmed: boolean;
}

export const resolveContinueGateDecision = ({
  isPaymentRecovery,
  hasRequiredUnmatched,
  formInvalid,
  hasPartialErrors,
  continueConfirmed,
}: ContinueGateInput): ContinueGateDecision => {
  // Unmatched-required outranks the generic invalid block so the actionable toast wins.
  if (isPaymentRecovery && hasRequiredUnmatched) {
    return 'block-unmatched';
  }
  if (formInvalid) {
    return 'block-invalid';
  }
  if (hasPartialErrors && !continueConfirmed) {
    return 'confirm-continue';
  }
  return 'proceed';
};

export type SaveAndExitDecision = 'block-unmatched' | 'confirm-save-anyway' | 'proceed';

export interface SaveAndExitInput {
  isPaymentRecovery: boolean;
  hasRequiredUnmatched: boolean;
  hasPartialErrors: boolean;
}

export const resolveSaveAndExitDecision = ({
  isPaymentRecovery,
  hasRequiredUnmatched,
  hasPartialErrors,
}: SaveAndExitInput): SaveAndExitDecision => {
  if (isPaymentRecovery && hasRequiredUnmatched) {
    return 'block-unmatched';
  }
  if (!isPaymentRecovery && hasPartialErrors) {
    return 'confirm-save-anyway';
  }
  return 'proceed';
};
